/**
 * Silent diagnostic logging to localStorage.
 *
 * CRITICAL: This module must NOT:
 * - Import or use zustand
 * - Import or use React hooks
 * - Subscribe to anything
 * - Update any React state
 *
 * Pure synchronous localStorage access only.
 * Any re-render pressure would invalidate diagnostic results.
 */

export function logDiagnostic(event: Record<string, any>): void {
  try {
    if (typeof window === "undefined") return;
    const timestamp = Date.now();
    const entry = JSON.stringify({ t: timestamp, ...event });
    const existing = window.localStorage.getItem("forge-diag-log") || "";
    let updated = existing + entry + "\n";

    // Cap at 50000 chars — trim oldest half if over
    if (updated.length > 50000) {
      const lines = updated.split("\n");
      updated = lines.slice(Math.floor(lines.length / 2)).join("\n");
    }

    window.localStorage.setItem("forge-diag-log", updated);
  } catch {
    // localStorage can fail (private mode, quota exceeded, etc) — silently swallow
  }
}

export function getDiagnosticLog(): string {
  try {
    return window.localStorage.getItem("forge-diag-log") || "";
  } catch {
    return "";
  }
}

export function clearDiagnosticLog(): void {
  try {
    window.localStorage.removeItem("forge-diag-log");
  } catch {}
}
